import React, { useRef, useState, } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Badge, IconButton, Button, List, ListItem, ListItemAvatar, ListItemText, Popover, SvgIcon, Tooltip, Typography, makeStyles, colors, Avatar, } from '@material-ui/core';
import { useSelector } from "react-redux";
import { Bell as BellIcon, } from 'react-feather';
import FlexbaseHttp, * as api from "src/utils/api";
import WebSocketService from 'src/services/webSocket';
import EventCell from "../../components/cells/EventCell";
const useStyles = makeStyles((theme) => ({
    popover: {
        width: 320
    },
    listItem: {
        color: theme.palette.text.primary,
    }
}));
function Notifications() {
    const classes = useStyles();
    const ref = useRef(null);
    const [isOpen, setOpen] = useState(false);
    const [result, setResult] = useState({
        results: []
    });
    const [notificationCount, setNotificationCount] = useState(0);
    const { user } = useSelector((state) => (state as any).account);
    const fetchNotifications = () => {
        const socket = new WebSocketService();
        socket.onReceiveMessage = data => {
            // @ts-ignore - paginated response
            setResult(_result => ({
                ...result,
                results: [data, ..._result.results] // todo - why does this need to be paginated?
            }));
            setNotificationCount(_count => _count + 1);
        };
        socket.connect();
        // Add callbacks to websocket instance to handle notifications
        new FlexbaseHttp('/automatic/notifications/').get()
            .then((result) => {
            setResult(result);
            const count = result.results.filter((notification: any) => !notification.readDatetime).length;
            setNotificationCount(count);
        })
            .catch(() => { });
    };
    const handleOpen = () => {
        setOpen(true);
        api.readNotifications();
    };
    const handleClose = () => {
        setOpen(false);
        setNotificationCount(0);
    };
    React.useEffect(fetchNotifications, []);
    const notifications = result.results || [];
    return (<>
      <Tooltip title="Notifications">
        <IconButton color="inherit" ref={ref} onClick={handleOpen}>
          <Badge color="primary" badgeContent={notificationCount}>
            <SvgIcon>
              <BellIcon />
            </SvgIcon>
          </Badge>
        </IconButton>
      </Tooltip>
      <Popover anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
    }} classes={{ paper: classes.popover }} anchorEl={ref.current} onClose={handleClose} open={isOpen}>
        <Box p={2}>
          <Typography variant="h5" color="textPrimary">
            Notifications
          </Typography>
        </Box>
        {notifications.length === 0 ? (<Box p={2}>
            <Typography variant="h6" color="textPrimary">
              There are no notifications
            </Typography>
          </Box>) : (<Box>
            <List className={(classes as any).list} disablePadding>
              {notifications.slice(0, 6).map((notification) => {
                // @ts-ignore
                const url = `/engagements/${notification.event.engagementId}/`
                return (<ListItem className={classes.listItem} component={RouterLink} divider key={(notification as any).id} to={url} onClick={handleClose}>
                            <EventCell event={(notification as any).event}/>
                          </ListItem>);
    })}
            </List>
            <Box p={1} display="flex" justifyContent="center">
              <Button component={RouterLink} size="small" onClick={() => setOpen(false)} fullWidth to="/dashboard/notifications">
                See all
              </Button>
            </Box>
          </Box>)}
      </Popover>
    </>);
}
export default Notifications;
